import postAPI from './postAPI.js'

export default async function postCancelStepSigning(body) {
    const data = await postAPI('taskinstances/steps/signing/cancel', body);
    return data;
}
